import React, { useEffect, useState } from 'react'
import { Billing } from '../../types/types'
import './BillingInfoTop.css'
import { NumericFormat } from 'react-number-format'
import Square from '../../atoms/Sqaure/Square'
import useMediaQuery from '../../../hook/useMediaQuery'
import { MediaDesktop, MediaMobile, MediaTablet } from '../../../api/const/MediaQuery'
import useMediaQueryMinMax from '../../../hook/useMediaQueryMinMax'
import clsx from 'clsx'

interface iBillingInfoTop {
  billing: Billing | undefined
}

const BillingInfoTop = ({ billing }: iBillingInfoTop) => {

  const mobile = useMediaQuery(MediaMobile)
  const tablet = useMediaQuery(MediaTablet)


  const smallDevices = useMediaQuery(767.98)



  return (
    <div className={clsx(' w-100   position-relative billings-top  d-flex pt-3 pb-3 align-items-center ' ,
    {"ms-5" : !mobile}
    )}>
      {!smallDevices && <Square
        bottom={ !tablet && !mobile ? "-25%" : tablet && !mobile ? "" :  tablet && mobile ? "" : "-25%"}
        left={!tablet && !mobile ? "-5%" : tablet && !mobile ? "-10%" :  tablet && mobile ? "-15%" : "-5%"}
        top={!tablet && !mobile ? "" : tablet && !mobile ? "-25%" : tablet && mobile ? "-25%" : "-5%"}
        title={billing?.month ?? ""}
        bodyText={billing?.year?.toString() ?? ""} />}
        {smallDevices && <div className='small-sqaure'></div>}
      <div className="row w-100 align-items-center justify-content-between">

        <div className='col-xs-12 col-md-6'>
          <div className='billings-top-left '>
            {smallDevices && <div className='d-flex'>
              <h4 className='text-uppercase '>{billing?.month} {billing?.year}</h4>
            </div>}
            <div className='d-flex'>
              <h5 className='m-0'>
                <span className='ms-2 tx-primary text-uppercase'>
                  {billing?.planName}
                </span>
              </h5>
            </div>
            <div className='d-flex'>
              <h5 className='m-0'>
                Monthly Direct Contact:
                <span className='ms-2 tx-primary text-uppercase'>
                  {billing?.doneMonthContact}/{billing?.maxMonthContact}
                </span>
              </h5>
            </div>
            <div className='d-flex'>
              <h5 className='m-0'>
                Yearly Meeting:
                <span className='ms-2 tx-primary text-uppercase'>
                  {billing?.doneYearMeeting}/{billing?.maxYearlyMeeting}
                </span>
              </h5>
            </div>
          </div>
        </div>

        <div className='
        mt-3 mt-md-0
        col-xs-11 
        col-md-6'>
          <div className='billings-top-right p-3'>
            <div className="row">
              <div className='font-weight-normal col-xs-6 col-md-12'>EXTRA TOTAL:</div>
              <h3 className='col-xs-6 col-md-12'>
                <NumericFormat
                  suffix='€'
                  value={billing?.total ?? 0}
                  className=''
                  type="text"
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </h3>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
export default BillingInfoTop